export const UPDATE_COUNT =
  'app/store/navigationCount/UPDATE_NOTIFICATION_COUNT'

export const UPDATE_COUNTS =
  'app/store/navigationCount/UPDATE_NOTIFICATION_COUNTS'

export const FETCH_COUNTS = 'app/store/navigationCount/FETCH_COUNTS'
